import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";
import path from "path";

const CustomersList = Loadable(
	lazy(() =>
		import("./CustomersList").then(({ CustomersList }) => ({
			default: CustomersList,
		}))
	)
);

const CustomerOverview = Loadable(
	lazy(() =>
		import("./components/CustomerOverview/CustomerOverview").then(
			({ CustomerOverview }) => ({
				default: CustomerOverview,
			})
		)
	)
);

const EditCustomer = Loadable(
	lazy(() =>
		import("./EditCustomer").then(({ EditCustomer }) => ({
			default: EditCustomer,
		}))
	)
);

export const customerRoutes = [
	{
		path: "/view-customers",
		exact: true,
		element: (
			<AuthorizedRoute
			
				moduleIds={[ALLOWED_MODULES.CUSTOMER]}
			>
				<CustomersList />
			</AuthorizedRoute>
		),
	},
	{
		path: "/customer-overview/:id",
		exact: true,
		element: (
			<AuthorizedRoute
				
				moduleIds={[ALLOWED_MODULES.CUSTOMER]}
			>
				<CustomerOverview />
			</AuthorizedRoute>
		),
	},
	{
		path: "/edit-customer/:id",
		exact: true,
		element: (
			<AuthorizedRoute
			
				moduleIds={[ALLOWED_MODULES.CUSTOMER]}
			>
				<EditCustomer />
			</AuthorizedRoute>
		),
	},
];
